import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { Overlay, TooltipBase, TooltipBubble, Trigger } from './styles'
import { documentBodyUnfreeze } from 'client/utils'

const Tooltip = ({ content, maxContainerWidth, children, theme }) => {
  const [isOpen, setOpen] = useState(false)
  const [position, setPosition] = useState('center')
  const trigger = useRef(null)

  useEffect(() => {
    if (trigger.current) {
      const { right, left } = trigger.current.getBoundingClientRect()

      if (left < maxContainerWidth / 2) {
        setPosition('left')
      } else if (window.innerWidth - right < maxContainerWidth / 2) {
        setPosition('right')
      }
    }
  }, [maxContainerWidth])

  const handleClick = e => {
    e.stopPropagation()
    setOpen(true)
  }

  const handleBlur = e => {
    e.stopPropagation()
    if (document.body.style.top) {
      documentBodyUnfreeze()
    }
    setOpen(false)
  }

  return (
    <>
      <Overlay data-testid="tooltip-overlay" visible={isOpen} onClick={handleBlur} />
      <TooltipBase>
        <TooltipBubble
          isOpen={isOpen}
          position={position}
          role="tooltip"
          theme={theme}
          width={maxContainerWidth}
          onClick={e => e.stopPropagation()}
        >
          {content}
        </TooltipBubble>

        <Trigger type="button" onClick={handleClick} ref={trigger}>
          {children}
        </Trigger>
      </TooltipBase>
    </>
  )
}

Tooltip.propTypes = {
  children: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
  maxContainerWidth: PropTypes.number,
  theme: PropTypes.string,
}

export default Tooltip
